import React from "react";
import {
  Button,
  Heading,
  Box,
  HStack,
  FormControl,
  FormLabel,
  Input,
  FormHelperText,
  Center,
} from "@chakra-ui/react";

const PersonForm = ({
  addPerson,
  newName,
  handleNewPerson,
  newNumber,
  handleNewNumber,
}) => {
  return (
    <>
      <Box maxWidth="480px">
        <Heading as="h2" mb="30px">
          Add a Record
        </Heading>
        <Box
          display={{ base: "flex" }}
          mt={{ base: "40px" }}
          alignItems={{ base: "center" }}
        >
          <form onSubmit={addPerson}>
            <FormControl mb="20px">
              <HStack>
                <FormLabel>Name</FormLabel>
                <Input
                  name="title"
                  type="text"
                  value={newName}
                  onChange={handleNewPerson}
                  placeholder="Eg: Mujtaba Ali"
                />
              </HStack>
              {newName.length < 3 && newName.length !== 0 ? (
                <FormHelperText color="red">
                  Enter Person Name of More Than 2 Letters
                </FormHelperText>
              ) : newName.length === 0 ? (
                <FormHelperText color="black">
                  Enter Person Name of More Than 2 Letters
                </FormHelperText>
              ) : (
                <FormHelperText color="green">
                  Enter Person Name of More Than 2 Letters
                </FormHelperText>
              )}
            </FormControl>

            <FormControl mb="20px">
              <HStack>
                <FormLabel>Number</FormLabel>
                <Input
                  name="number"
                  type="text"
                  value={newNumber}
                  onChange={handleNewNumber}
                  placeholder="Eg: 11-111111 , 123-444444"
                />
              </HStack>
              {newNumber.length < 8 && newNumber.length !== 0 ? (
                <FormHelperText color="red">
                  Enter Phonenumber of More Than 8 Digits in the above Format
                </FormHelperText>
              ) : newNumber.length === 0 ? (
                <FormHelperText color="black">
                  Enter Phonenumber of More Than 8 Digits in the above Format
                </FormHelperText>
              ) : (
                <FormHelperText color="green">
                  Enter Phonenumber of More Than 8 Digits in the above Format
                </FormHelperText>
              )}
            </FormControl>
            <Box>
              <Button type="submit" colorScheme="green">
                Add
              </Button>
            </Box>
          </form>
        </Box>
      </Box>
    </>
  );
};

export default PersonForm;
